var _mask, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmbedInteractive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "path-1-inside-1_15523_12299",
  fill: "white"
}, /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 3,
  width: 14,
  height: 10,
  rx: 1
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 1,
  y: 3,
  width: 14,
  height: 10,
  rx: 1,
  stroke: "currentcolor",
  strokeWidth: 3,
  mask: "url(#path-1-inside-1_15523_12299)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4.21967 6.71967C4.07902 6.86032 4 7.05109 4 7.25C4 7.44891 4.07902 7.63968 4.21967 7.78033C4.36032 7.92098 4.55109 8 4.75 8H5.5V8.75C5.5 8.94891 5.57902 9.13968 5.71967 9.28033C5.86032 9.42098 6.05109 9.5 6.25 9.5C6.44891 9.5 6.63968 9.42098 6.78033 9.28033C6.92098 9.13968 7 8.94891 7 8.75V8H7.75C7.94891 8 8.13968 7.92098 8.28033 7.78033C8.42098 7.63968 8.5 7.44891 8.5 7.25C8.5 7.05109 8.42098 6.86032 8.28033 6.71967C8.13968 6.57902 7.94891 6.5 7.75 6.5H7V5.75C7 5.55109 6.92098 5.36032 6.78033 5.21967C6.63968 5.07902 6.44891 5 6.25 5C6.05109 5 5.86032 5.07902 5.71967 5.21967C5.57902 5.36032 5.5 5.55109 5.5 5.75V6.5H4.75C4.55109 6.5 4.36032 6.57902 4.21967 6.71967Z",
  fill: "currentcolor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M11.7803 9.78033C11.921 9.63968 12 9.44891 12 9.25C12 9.05109 11.921 8.86032 11.7803 8.71967C11.6397 8.57902 11.4489 8.5 11.25 8.5H11V8.25C11 8.05109 10.921 7.86032 10.7803 7.71967C10.6397 7.57902 10.4489 7.5 10.25 7.5C10.0511 7.5 9.86032 7.57902 9.71967 7.71967C9.57902 7.86032 9.5 8.05109 9.5 8.25V8.5H9.25C9.05109 8.5 8.86032 8.57902 8.71967 8.71967C8.57902 8.86032 8.5 9.05109 8.5 9.25C8.5 9.44891 8.57902 9.63968 8.71967 9.78033C8.86032 9.92098 9.05109 10 9.25 10H9.5V10.25C9.5 10.4489 9.57902 10.6397 9.71967 10.7803C9.86032 10.921 10.0511 11 10.25 11C10.4489 11 10.6397 10.921 10.7803 10.7803C10.921 10.6397 11 10.4489 11 10.25V10H11.25C11.4489 10 11.6397 9.92098 11.7803 9.78033Z",
  fill: "currentcolor"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmbedInteractive);
export default ForwardRef;